(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7642],{

/***/ 8260:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de/blog",
      function () {
        return __webpack_require__(601);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4468);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7058);
/* harmony import */ var _layouts_BlogLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8862);
/* harmony import */ var _atoms_Column__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4992);
/* harmony import */ var _atoms_LinkComponent__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2964);
/* harmony import */ var _elements_NewsletterSection__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8108);
/* harmony import */ var _grids_PostsGrid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3237);
/* harmony import */ var _meta_SEO__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8897);
/* harmony import */ var _atoms_Section__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9748);
// import node_modules





// import component







// define page
var BlogTemplate = function(param) {
    var blogTags = param.blogTags, blogPosts = param.blogPosts, hrefLang = param.hrefLang;
    // init hooks
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_10__/* .useTranslation */ .$)("blog").t;
    // init vars
    var totalPosts = blogPosts.length || 20;
    // init render
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_meta_SEO__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                description: t("seo.description"),
                hrefLang: hrefLang,
                image: t("seo.image"),
                title: t("seo.title")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layouts_BlogLayout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                blogTags: blogTags,
                hrefLang: hrefLang,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                                height: "64px"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                                mobileHeight: "25px",
                                tabletHeight: "50px",
                                height: "75px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_atoms_Column__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            cols: "ml",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6, {
                                    alignment: "center",
                                    tag: "h1",
                                    isHyphenated: false,
                                    children: t("hero.title")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                    alignment: "center",
                                    size: "large",
                                    children: t("hero.intro")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                            mobileHeight: "25px",
                            tabletHeight: "25px",
                            height: "25px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_grids_PostsGrid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        bgColor: "white",
                        blogPosts: blogPosts
                    }),
                    totalPosts > 20 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Column__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "button-container",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_LinkComponent__WEBPACK_IMPORTED_MODULE_5__["default"], {
                                    href: t("nextPage.href"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .LinkButton */ .Qj, {
                                        color: "naked",
                                        size: "large",
                                        text: t("nextPage.label"),
                                        iconRight: "ri-arrow-right-line",
                                        textIsPrimary: true
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                            mobileHeight: "50px",
                            tabletHeight: "50px",
                            height: "50px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        bgColor: "desertStorm",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                            height: "100px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_NewsletterSection__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        bgColor: "desertStorm"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        bgColor: "desertStorm",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                            height: "100px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                            height: "50px"
                        })
                    })
                ]
            })
        ]
    });
};
BlogTemplate.propTypes = {
    blogPosts: prop_types__WEBPACK_IMPORTED_MODULE_11__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_11__.shape({
        image: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired,
        slug: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired,
        tags: prop_types__WEBPACK_IMPORTED_MODULE_11__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired).isRequired,
        title: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired
    }).isRequired).isRequired,
    blogTags: prop_types__WEBPACK_IMPORTED_MODULE_11__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_11__.shape({
        slug: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired,
        title: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired
    }).isRequired).isRequired,
    hrefLang: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogTemplate);


/***/ }),

/***/ 601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_templates_BlogTemplate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9425);
// import node_modules



// import component

// define page
var BlogPage = function(param) {
    var blogTags = param.blogTags, blogPosts = param.blogPosts, hrefLang = param.hrefLang;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_BlogTemplate__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        blogTags: blogTags,
        blogPosts: blogPosts,
        hrefLang: hrefLang
    });
};
BlogPage.propTypes = {
    blogPosts: prop_types__WEBPACK_IMPORTED_MODULE_3__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_3__.shape({
        image: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired,
        slug: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired,
        tags: prop_types__WEBPACK_IMPORTED_MODULE_3__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired).isRequired,
        title: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired
    }).isRequired).isRequired,
    blogTags: prop_types__WEBPACK_IMPORTED_MODULE_3__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_3__.shape({
        slug: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired,
        title: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired
    }).isRequired).isRequired,
    hrefLang: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (BlogPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4348,2539,675,7926,2457,9774,2888,179], function() { return __webpack_exec__(8260); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);